import { DatePipe } from "@angular/common";
import { Subject, takeUntil } from "rxjs";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FilterDefinition } from "./filters.model";
import { filter, share, switchMap } from "rxjs";
import { PlanyardService } from "../../planyard.service";
import { MatAutocomplete } from "@angular/material/autocomplete";

@Component({
  selector: "app-po-filter-dropdown",
  templateUrl: "./po-filter-dropdown.component.html",
  styleUrls: ["./po-filter-dropdown.component.scss"],
  providers: [DatePipe]
})
export class PoFilterDropdownComponent implements OnInit,OnDestroy {
  filteredData: any;
  form: FormGroup = new FormGroup({});
  private destroy$=new Subject<void>();
  
  filteredOptions$: any;
  vendorId: number;
  startRow = 0;
  amountPerPage = 10;
  startRowArray:any[]=[];
  @ViewChild('auto') public scroll!: MatAutocomplete;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FilterDefinition[],
    public dialogRef: MatDialogRef<PoFilterDropdownComponent>,
     private planyardService :PlanyardService) {}

  ngOnInit(): void {
    this.data.forEach((e: FilterDefinition) => {     
      if (e.type == "datepicker") {
        this.form.addControl(
          e.filterName, 
          this.setFormGroup("start", "end",e));         
      } 
      else if(e.type == 'mat-autocomplete') {
        this.form.addControl('autocomplete', new FormControl(e.currentValue ? e.currentValue : null));
      } 
      else {
        this.form.addControl(
          e.filterName,
          new FormControl(e.currentValue ? e.currentValue : null)
        );
      }
    });
    this.form.get("autocomplete")?.valueChanges.pipe(
      filter(e => typeof e === 'string'),
      switchMap((value:any) =>{
        if(value){
          this.startRow=0;
          const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
          if(idx != -1){
            this.startRowArray['startrow_']=0
          }else{
            this.startRowArray['startrow_'] = 0;  
          }
          return this.planyardService.TypeaheadItem(value, this.vendorId, null,this.startRow,this.startRow + this.amountPerPage)
        } else{
          let e = [];
          return e;
        }
      }),
      share()
    ).subscribe((e)=>{
      this.filteredOptions$ = e;
      this.startRowArray['startrow_']+= this.amountPerPage;
    })
    this.filteredData = this.data;
    this.hasAutocompleteControl();
  }
  
  hasAutocompleteControl(): boolean {
    return this.form.contains('autocomplete');
  }

  setFormGroup(keyName1,keyName2,e){
    return new FormGroup({
      [keyName1]: new FormControl(e.currentValue ? e.currentValue.start : null),
      [keyName2]: new FormControl(e.currentValue ? e.currentValue.end : null),
    });
  }

  resetFilter() {
    this.form.reset();
    const data = this.data.map(filter => {
      filter.currentValue = null;
      return filter;
    })
    this.dialogRef.close(data);
  }

  submit() {
    const formValue = this.form.value;
    const data = this.data.map((filter) => {
       filter.currentValue = formValue[filter.filterName];
      return filter;
    });
    this.dialogRef.close(data);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  displayWith(value: any) {
    if (value) {
      return value.title;
    }
  }

  loadAllOnScroll(event) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_')
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'];
      }else{
        this.startRowArray['startrow_'] = 0; 
        this.startRow=0;
      }
      const value= this.form.get("autocomplete").value;
      this.startRowArray['startrow_']+= this.amountPerPage;
      return this.planyardService.TypeaheadItem(value, this.vendorId, null,this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
       this.filteredOptions$.push(...res);
      });
    }
  } 

  registerPanelScrollEvent(element) {
    const panel = element;
   panel.addEventListener('scroll', event => this.loadAllOnScroll(event));
 }

  setScroll(){
    const element= document.getElementById(this.scroll.id);
      if(element){     
        this.registerPanelScrollEvent(element);
      }
    }
}
